import axios from "axios";
import localData from "@/utility/localData";
const DataList = {
    data: {
        // BaseUrl: 'http://localhost:3004/'
    },

    methods: {
        async fetchConductorTypes(source) {
            const token = localData.methods.getLocalToken();
            return await axios
                .get(source, { headers: { Authorization: `Bearer ${token}` } })
                .then((response) => {
                    // console.log('rese',response.data._items)
                    return response.data._items;
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    return null;
                });
        },

        async fetchData(source) {
            const token = localData.methods.getLocalToken();
            return await axios
                .get(source, { headers: { Authorization: `Bearer ${token}` } })
                .then((response) => {
                    return response.data._items;
                    //return response.data
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    return null;
                });
        },
        async fetchDataById(source, id) {
            return await axios
                .get(source + "/?id=" + id)
                .then((response) => {
                    //return response.data[0]
                    // console.log('param',source+'/?Title='+id)
                    // console.log('store',response.data[source])
                    return response.data[source][0];
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    return null;
                });
        },
    },
};
export default DataList;
